import React from 'react'
import { Redirect, Route as BaseRoute, Switch, useLocation } from 'react-router-dom'
import { observer } from '~/common/mobx.decorator'
import { Route } from './components/route'
import { FEATURES } from '~/features'
import { COMPANIES } from '~/companies'
import { PATHS } from './common/constants'
import { Tracking } from './tracking'
import { careStore } from '~/companies/care/care.store'
import { isEmpty } from 'lodash'
import { LinkedInCallback } from 'react-linkedin-login-oauth2'
import { logTrackingScreenEvent } from '~/common/tracking/event-client.tracking'
import { generateUUID } from '~/common/helpers/uid.helper'
import { eventClient } from '@opus/web.core.lib.event-tracking'

export const AppRoute = observer(() => {
	let location = useLocation()

	React.useEffect(() => {
		const code = careStore.allFeatures?.code
		async function loadScreenKeys() {
			if (!isEmpty(code)) {
				eventClient.setCurrentComponentName(code)
				eventClient.setCurrentUIKey(generateUUID())
				logTrackingScreenEvent(code)
			} else {
				eventClient.setCurrentComponentName('')
				eventClient.setCurrentUIKey('')
				eventClient.setCurrentComponentName('')
				eventClient.setCurrentUIKey('')
			}
		}
		loadScreenKeys()
	}, [location])

	return (
		<Switch>
			<BaseRoute
				exact
				sensitive
				path="/:url([a-z/]*[A-Z]+[a-z/]*)/"
				render={(props) => <Redirect to={{ pathname: `${props.location.pathname}`.toLowerCase() }} />}
			/>
			<BaseRoute path={PATHS.auth.profile_completion} component={FEATURES['profile-completion']} />

			<Route path={PATHS.common.tracking} component={Tracking} />
			<Route path={PATHS.common.signin} component={FEATURES['signin']} />
			<Route path={PATHS.common.signup} component={FEATURES['signup']} />
			<Route path={PATHS.common.errors} component={FEATURES['errors']} />
			<Route path={PATHS.common.reset} component={FEATURES['reset']} />
			<Route path={PATHS.common.link_account} component={FEATURES['link-account']} />
			<Route path={PATHS.common.link_options} component={FEATURES['link-options']} />
			<Route path={PATHS.common.home} component={COMPANIES.care} />
			<Route path={PATHS.common.verify_credential} component={FEATURES['verify-credential']} />
			<Route path={PATHS.common.sso_authentication} component={FEATURES['common-sso']} />
			<Route exact path={PATHS.auth.linkedin} component={LinkedInCallback} />
		</Switch>
	)
})
